<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="在线用户名称" prop="loginUserName">
        <el-input v-model.trim="queryParams.loginUserName" placeholder="请输入在线用户名称" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="登录IP地址" prop="loginIp">
        <el-input v-model.trim="queryParams.loginIp" placeholder="请输入登录IP地址" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['monitor:online:exitUser']" type="danger" plain icon="el-icon-delete" size="mini"
          :disabled="multiple" @click="handleBatchExit">强退</el-button>
      </div>
      <div class="table-box">
        <auto-height-table ref="onlineTable" :class="{ 'empty': list.length === 0 }" empty-text=" " v-loading="loading"
          :data="list" row-key="logId" @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column type="selection" :reserve-selection="true" width="55" align="center" />
          <el-table-column-dict maskType="mobile" label="在线用户名" prop="loginUserName" align="center" min-width="139px" />
          <el-table-column-dict :maskStart="4" :maskEnd="4" label="登录IP地址" align="center" prop="loginIp" min-width="128px"></el-table-column-dict>
          <el-table-column label="浏览器" align="center" min-width="139px">
            <template slot-scope="scope">
              {{ parseUserAgent(scope.row.browser).browser }}
            </template>
          </el-table-column>
          <el-table-column label="操作系统" align="center" min-width="158px">
            <template slot-scope="scope">
              {{ parseUserAgent(scope.row.browser).os }}
            </template>
          </el-table-column>
          <el-table-column-dict dictType="CHANNEL" dictTypeNode="tag" label="渠道" align="center" prop="loginChannel"
            min-width="100px"></el-table-column-dict>

          <el-table-column-dict dateFormat="datetime" label="登录日期" align="center" prop="loginTime"
            min-width="168px"></el-table-column-dict>
          <el-table-column v-if="
            mixinHasPermi([
              'monitor:online:exitUser',
            ])
          " label="操作" align="center" width="128px" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button v-hasPermission="['monitor:online:exitUser']" size="mini"
                type="danger" icon="el-icon-delete" @click.native.stop="handleExit(scope.row)">强退</el-button>
            </template>
          </el-table-column>
        </auto-height-table>
        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>
  </div>
</template>

<script>
import { monitorApi } from "@/api"
export default {
  name: "monitorOnlineManage",
  data() {
    return {
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        loginUserName: "", // 任务名称
        loginIp: "", // 执行任务标识
        pageSize: 10, // 每页条数
        pageNum: 1 // 当前页
      },
      list: [],
      selection: [], //选中的项
      loading: false,
      total: 0,

      // 非单个禁用
      single: true,
      // 非多个禁用(0个禁用)
      multiple: true,

      open: false,
      // 表单参数
      baseForm: {
        scheduleName: "", // 任务名称
        taskName: "", // 执行任务标识
        cron: "", // cron执行表达式
        remark: "" // 备注
      }

    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          scheduleName: "", // 任务名称
          taskName: "", // 执行任务标识
          cron: "", // cron执行表达式
          remark: "" // 备注
        }
        this.$refs.scheduleDialog && this.$refs.scheduleDialog.resetForm()
      }
    }
  },
  created() {
    //获取列表
    this.getList()
  },
  methods: {
    //点击行
    clickRow(row) {
      this.$refs.onlineTable.toggleRowSelection(row)
    },
    //批量强退
    handleBatchExit() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      const _this = this
      let str = ""
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        str += item.loginUserName
        if (i !== this.selection.length - 1) {
          str += ", "
        }
      }

      this.$modal
        .confirm('是否确认强退登录用户名为"【' + str + '】"的用户？')
        .then(function() {
          return monitorApi.batchExitUsers({ list: _this.selection })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量强退用户成功")
        })
        .catch(() => { })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // 清空已选项
      this.$refs.onlineTable.clearSelection()
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      this.loading = true
      monitorApi
        .getOnlineUserList(this.queryParams)
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 删除按钮操作 */
    handleExit(row) {
      this.mixinBtnBlur()

      this.$modal
        .confirm('是否确认强退登录用户名为"【' + row.loginUserName + '】"的用户？')
        .then(function() {
          return monitorApi.batchExitUsers({ list: [row] })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("强退用户成功")
        })
        .catch(() => { })
    },
    // 通过userAgent字符串解析出浏览器、操作系统和移动设备等信息
    parseUserAgent(ua) {
      const result = {
        browser: "Unknown",
        version: "Unknown",
        os: "Unknown",
        isMobile: false
      }

      // 检测Chrome
      if (ua.includes("Chrome")) {
        result.browser = "Chrome"
        const chromeVersion = ua.match(/Chrome\/([\d.]+)/)
        if (chromeVersion) { result.version = chromeVersion[1] }
      }
      // 可添加其他浏览器检测逻辑...

      // 检测操作系统
      if (ua.includes("Windows NT 10.0")) {
        result.os = "Windows 10"
        if (ua.includes("Win64") || ua.includes("x64")) {
          result.os += " 64-bit"
        }
      }

      // 检测移动设备
      result.isMobile = /Android|iPhone|iPad|iPod/i.test(ua)

      return result
    }
  }
}
</script>